import { createMemoryCache, createNullCache } from '@algolia/client-common'
import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { initialApiKey, registerSecuredApiKeyClient } from 'algolia/secured-api-key'
import configLoader from 'config/helper'

export const searchClient = algoliasearch(
  configLoader('algoliaAppId.id') as string,
  initialApiKey,
  { responsesCache: typeof window === 'undefined' ? createNullCache() : createMemoryCache() },
)

// This module is imported from both runtimes. On the server `initialApiKey` is the real key and
// stays in use; in the browser it is a placeholder until the server-signed secured key is applied.
registerSecuredApiKeyClient(searchClient)
